import React from 'react'

import assets from '../assets'
import styles from '../Styles/Global'
import { client, urlFor } from "../../../client";


const FeatureCard = ({ techStack }) => {
	return (
		<>
			{techStack.map((tech, index) => (
				<div key={index} className={styles.featureCard}>
					<img
						src={urlFor(tech.technologyImage).url()}
						alt={tech.technologyName}
						className={styles.featureImg}
					/>
					<p className={styles.featureText}>
						{tech.technologyName}
					</p>
				</div>
			))}
		</>
	);
};




function Features({ techStack, technologyDescription }) {
	return (
		<div
			className={`${styles.section} ${styles.bgPrimary} banner03`}
		>
			<div
				className={`${styles.subSection} flex-col text-center`}
			>
				<div>
					<h1
						className={`${styles.h1Text} ${styles.whiteText}`}
					>
						Technologies
					</h1>
					<p
						className={`${styles.pText} ${styles.whiteText}`}
					>
						{technologyDescription}
					</p>
				</div>
				<div className={styles.flexWrap}>
					<FeatureCard techStack={techStack} />
				</div>
			</div>
		</div>
	);
}

export default Features